import styled from '@emotion/styled';
import { gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    grid-gap: ${gutterSizes.large};
`;
